"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = void 0;
var eva_js_1 = require("@eva/eva.js");
var plugin_renderer_img_1 = require("@eva/plugin-renderer-img"); // 引入渲染图片所需要的组件和系统
var plugin_renderer_nine_patch_1 = require("@eva/plugin-renderer-nine-patch");
var plugin_renderer_text_1 = require("@eva/plugin-renderer-text");
var plugin_transition_1 = require("@eva/plugin-transition");
var render_1 = __importDefault(require("../render"));
// 资源
exports.Source = [{
        name: 'smallModel',
        type: eva_js_1.RESOURCE_TYPE.IMAGE,
        src: {
            image: {
                type: 'png',
                url: './resource3d/model/smallModel.png'
            }
        },
        preload: true
    }, {
        name: 'middleModel',
        type: eva_js_1.RESOURCE_TYPE.IMAGE,
        src: {
            image: {
                type: 'png',
                url: './resource3d/model/middleModel.png'
            }
        },
        preload: true
    }, {
        name: 'bigModel',
        type: eva_js_1.RESOURCE_TYPE.IMAGE,
        src: {
            image: {
                type: 'png',
                url: './resource3d/model/bigModel.png'
            }
        },
        preload: true
    }];
var DialogBox = /** @class */ (function () {
    function DialogBox() {
        this.model = null;
        this.textSpan = null;
        this.line = null;
        this.textComponent = null;
        this.instanceDialogBox = null;
        this.interval = null;
        this.modelWidth = 120;
        this.modelHeight = 46;
        this.modelBg = null;
        this.initResource();
        this.textGame();
        this.modelGame();
    }
    Object.defineProperty(DialogBox, "instance", {
        get: function () {
            this.instanceDialogBox = this.instanceDialogBox || new DialogBox();
            return this.instanceDialogBox;
        },
        enumerable: false,
        configurable: true
    });
    DialogBox.prototype.initResource = function () {
        render_1.default.addResource(exports.Source).addSystem([new plugin_renderer_img_1.ImgSystem(), new plugin_renderer_nine_patch_1.NinePatchSystem(), new plugin_renderer_text_1.TextSystem(), new plugin_transition_1.TransitionSystem()]);
    };
    DialogBox.prototype.modelGame = function () {
        // 创建 game object
        this.model = new eva_js_1.GameObject('patch', {
            size: { width: this.modelWidth, height: this.modelHeight },
            origin: { x: 0, y: 0 },
            position: {
                x: 125,
                y: 15
            },
            anchor: {
                x: 0,
                y: 0
            },
            scale: {
                x: 0,
                y: 0
            }
        });
        this.modelBg = this.model.addComponent(new plugin_renderer_img_1.Img({
            resource: 'middleModel'
        }));
        this.model.addChild(this.textSpan);
    };
    DialogBox.prototype.textGame = function () {
        this.textSpan = new eva_js_1.GameObject('text', {
            size: { width: this.modelWidth - 10, height: this.modelHeight },
            position: {
                x: -48,
                y: -13
            },
            origin: {
                x: 0,
                y: 0
            },
            anchor: {
                x: 0.5,
                y: 0.5
            }
        });
        this.textComponent = this.textSpan.addComponent(new plugin_renderer_text_1.Text({
            text: '',
            style: {
                fontSize: 11,
                fontWeight: 'normal',
                fill: ['#002A3C'],
                wordWrap: true,
                wordWrapWidth: 100,
                breakWords: true,
                lineHeight: 14
            }
        }));
    };
    DialogBox.prototype.setText = function (sayText) {
        var len = sayText.length;
        if (len <= 10) {
            this.modelBg.resource = 'middleModel';
            this.model.transform.size.height = 56;
            this.textSpan.transform.position.y = -10;
        }
        else if (len > 10 && len <= 20) {
            this.modelBg.resource = 'middleModel';
            this.model.transform.size.height = 56;
            this.textSpan.transform.position.y = -16;
        }
        else {
            this.modelBg.resource = 'bigModel';
            this.model.transform.size.height = 66;
            this.textSpan.transform.position.y = -24;
        }
        this.textComponent.text = sayText;
    };
    DialogBox.prototype.load = function () {
        return this.model;
    };
    DialogBox.prototype.setContainer = function (_a) {
        var width = _a.width, height = _a.height;
        this.model.position = {
            x: width,
            y: height
        };
        this.textSpan.position = {
            x: width / 4,
            y: height / 3
        };
    };
    DialogBox.prototype.remove = function () {
        render_1.default.game.removeGameObject(this.model);
        render_1.default.game.removeGameObject(this.textSpan);
    };
    DialogBox.prototype.destroy = function () {
        render_1.default.game.scene.destroy();
    };
    return DialogBox;
}());
exports.default = DialogBox.instance;
